import { Link } from "gatsby"
import React from "react"

const MobileNavbar = ({ as }) => {
  return (
    <div className="side-menu__block">
      <div className="side-menu__block-overlay custom-cursor__overlay">
        <div className="cursor"></div>
        <div className="cursor-follower"></div>
      </div>
      <div className="side-menu__block-inner ">
        <div className="side-menu__top justify-content-end">
          <a href="#" className="side-menu__toggler side-menu__close-btn">
            <img src="/assets/images/shapes/close-1-1.png" alt="close menu" />
          </a>
        </div>
        <nav className="mobile-nav__container"></nav>
        <div className="side-menu__sep"></div>
        {/*
          <div className="side-menu__content">
            <p>Tripo is a premium wordpress theme for travel, tours, trips, adventures and a wide range of other tour agencies.</p>
            <p><a href="mailto:needhelp@tripo.com">needhelp@tripo.com</a> <br> <a href="tel:888-999-0000">888 999 0000</a></p>
            <div className="side-menu__social">
              <a href="#"><i className="fab fa-facebook-square"></i></a>
              <a href="#"><i className="fab fa-twitter"></i></a>
              <a href="#"><i className="fab fa-instagram"></i></a>
              <a href="#"><i className="fab fa-pinterest-p"></i></a>
            </div>
          </div>
*/}
      </div>
    </div>
  )
}

export default MobileNavbar
